import {cancel, HybirdBridge, invoke, on} from "@hybird/core/bridge/hybirdBridge";
import {BridgeMethod} from "@hybird/core/bridge/core";

export class FlutterTest extends BridgeMethod {

  constructor() {
    super();
  }


  /**
   * 监听测试
   *
   * on: onTest 推送测试数据
   * @param callback
   */
  onTest(callback) {
    return on("onTest", callback, {isSend: true});
  }

  /**
   * 监听测试
   *
   * on: onTest 推送测试数据
   * @param callback
   */
  offTest(callback) {
    return cancel("onTest", {event: callback, isSend: true});
  }


  /**
   * 开启测试
   *
   * @param params{{}}
   * on: onTest 推送测试数据
   * @param on{{onTest:function}}
   */
  openTest({params = {}, on = {}}) {
    return invoke("openTest", {params, on});
  }

  /**
   * 关闭test
   * @param params{{}}
   */
  closeTest(params) {
    return invoke("closeTest", {params});
  }

  /**
   * 下载文件
   *
   * @param params{{}}onTest
   * @param on{{onProgress:function({}), onFinish:function({})}}
   */
  testDownFile({params = {}, on = {}}) {
    return invoke("testDownFile", {params, on});
  }
}